import useBootstrapData from '@/hooks/useBootstrapData'
import {
  transformAbandonedHotelApiResponseToProps,
  transformAbandonedCarApiResponseToProps
} from '@/components/TripActivity/utils'
import useSeti from '@/hooks/useSeti'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import useAbandonedTrip from './useAbandonedTrip'

function useTripActivityData() {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn }
  } = useBootstrapData()

  const abandonedTripResponse = useAbandonedTrip(
    clientGUID,
    {
      appName,
      appVersion
    },
    signedIn
  )
  const { mostRecentFutureBooking } = useMostRecentFutureBooking()
  const hasCarSelection =
    abandonedTripResponse.length > 0 && 'carURL' in abandonedTripResponse[0]

  const showHotelEDSelectionsExperiment =
    useSeti('HP_HOTEL_ED_SELECTIONS') === 'VARIANT'
  const showRCAbandonedExperiment =
    useSeti('HP_RC_SELECTIONS', hasCarSelection) === 'VARIANT'

  const filteredAbandonedSelection = abandonedTripResponse.filter(value => {
    if ('hotelURL' in value) {
      /* eslint-disable no-underscore-dangle */
      return (
        Object.keys(value.temp_hotel).length > 0 &&
        (showHotelEDSelectionsExperiment
          ? true
          : value.temp_hotel.__typename === 'TEMP_CDP_RtlHotel')
      )
    }

    return 'carURL' in value && showRCAbandonedExperiment
  })

  let abandonedTripData = null
  if (filteredAbandonedSelection.length > 0) {
    const firstItem = filteredAbandonedSelection[0]

    if ('hotelURL' in firstItem) {
      abandonedTripData = transformAbandonedHotelApiResponseToProps(firstItem)
    } else {
      abandonedTripData = transformAbandonedCarApiResponseToProps(firstItem)
    }
  }

  const showAbandonedTrip =
    abandonedTripData !== null && !mostRecentFutureBooking

  const data = useRecentSearchCard(clientGUID, { appName, appVersion })
  const atMostFiveRecentSearchCards = data.length > 5 ? data.slice(0, 5) : data

  return {
    abandonedTripData,
    atMostFiveRecentSearchCards,
    showAbandonedTrip
  }
}

export default useTripActivityData
